import { TRANSACTION_TYPES } from '../../constants/transactionTypes'
import { calculatePointValue } from '../token.helpers'
import { TOKEN_TYPE } from '../../constants/token'
import { addNumbers } from '../number.helpers'
import { calculateExchangeInOutValue } from '../chart/transactionsGraph.helpers'

const buildTransferVolumeData = (
  { exchangeInTxValue, exchangeOutTxValue, rewardTxValue, redeemTxValue },
  transactionType
) => {
  switch (transactionType) {
    case TRANSACTION_TYPES.EXCHANGE:
      return {
        data: [addNumbers(exchangeInTxValue, exchangeOutTxValue), 0, 0]
      }
    case TRANSACTION_TYPES.REWARD:
      return {
        data: [0, rewardTxValue, 0]
      }
    case TRANSACTION_TYPES.REDEEM:
      return {
        data: [0, 0, redeemTxValue]
      }
    default:
      return {
        data: [
          addNumbers(exchangeInTxValue, exchangeOutTxValue),
          rewardTxValue,
          redeemTxValue
        ]
      }
  }
}

const buildTransactionsCountData = (
  { exchangeTxCount, rewardTxCount, redeemTxCount },
  transactionType
) => {
  switch (transactionType) {
    case TRANSACTION_TYPES.EXCHANGE:
      return {
        data: [exchangeTxCount, 0, 0]
      }
    case TRANSACTION_TYPES.REWARD:
      return {
        data: [0, rewardTxCount, 0]
      }
    case TRANSACTION_TYPES.REDEEM:
      return {
        data: [0, 0, redeemTxCount]
      }
    default:
      return {
        data: [exchangeTxCount, rewardTxCount, redeemTxCount]
      }
  }
}

const buildTransactionsRateData = (
  {
    exchangeInTxValue,
    exchangeOutTxValue,
    rewardTxValue,
    redeemTxValue,
    exchangeTxCount,
    rewardTxCount,
    redeemTxCount
  },
  transactionType
) => {
  switch (transactionType) {
    case TRANSACTION_TYPES.EXCHANGE:
      return {
        data: [
          addNumbers(exchangeInTxValue, exchangeOutTxValue) / exchangeTxCount,
          0,
          0
        ]
      }
    case TRANSACTION_TYPES.REWARD:
      return {
        data: [0, rewardTxValue / rewardTxCount, 0]
      }
    case TRANSACTION_TYPES.REDEEM:
      return {
        data: [0, 0, redeemTxValue / redeemTxCount]
      }
    default:
      return {
        data: [
          addNumbers(exchangeInTxValue, exchangeOutTxValue) / exchangeTxCount,
          rewardTxValue / rewardTxCount,
          redeemTxValue / redeemTxCount
        ]
      }
  }
}

const buildTransactionsValueData = (
  { exchangeInTxValue, exchangeOutTxValue, rewardTxValue, redeemTxValue },
  { offramp, onramp },
  transactionType
) => {
  switch (transactionType) {
    case TRANSACTION_TYPES.EXCHANGE:
      return {
        data: [
          calculateExchangeInOutValue(
            { exchangeInTxValue, exchangeOutTxValue },
            { offramp, onramp }
          ),
          0,
          0
        ]
      }
    case TRANSACTION_TYPES.REWARD:
      return {
        data: [0, calculatePointValue(rewardTxValue, onramp), 0]
      }
    case TRANSACTION_TYPES.REDEEM:
      return {
        data: [0, 0, calculatePointValue(redeemTxValue, onramp)]
      }
    default:
      return {
        data: [
          calculateExchangeInOutValue(
            { exchangeInTxValue, exchangeOutTxValue },
            { offramp, onramp }
          ),
          calculatePointValue(rewardTxValue, onramp),
          calculatePointValue(redeemTxValue, onramp)
        ]
      }
  }
}

const isPointsToken = (type) => {
  return [TOKEN_TYPE.ERC_20, TOKEN_TYPE.EXTERNAL].includes(type)
}

const isTokenFullIntegration = (type) => {
  return type === TOKEN_TYPE.ERC_20
}

const extractUserPointsBalance = (balances) => {
  if (balances && balances.length > 0) {
    const filterPoints = balances.filter((balance) =>
      isPointsToken(balance?.token?.type)
    )
    return filterPoints.length > 0 ? filterPoints[0].balance : 0
  }
  return 0
}

export {
  buildTransferVolumeData,
  buildTransactionsCountData,
  buildTransactionsRateData,
  buildTransactionsValueData,
  extractUserPointsBalance,
  isTokenFullIntegration
}
